// Pure legacy-key check shared by <Policy>, the home menu and the permisos
// context. Kept free of React and context imports so it can be used anywhere
// without import cycles.
function policyExists(policy, policiesAllow = []) {
  if (policy == "") {
    return true;
  }
  return policiesAllow.includes(policy);
}

export const policyAllow = (policy, policiesAllow = []) => {
  let allow = false;
  if (policy == "") {
    return true;
  }
  if (typeof policy == "object") {
    if (!policy.length) {
      allow = true;
    } else {
      policy.forEach((p) => {
        if (policyExists(p, policiesAllow)) {
          allow = true;
        }
      });
    }
  } else {
    allow = policyExists(policy, policiesAllow);
  }
  return allow;
};
